module.exports = __webpack_public_path__ + "media/images/categories/support-e5a0c491ca16be78303767e376a00912.png";